import React from "react";
import ContentLoader from "react-content-loader";

const MatchInfoLoading = (props) => {
  return (
    <div className="h-full px-2 sm:px-20 lg:px-4">
      <ContentLoader
        speed={2}
        viewBox="0 0 300 320"
        backgroundColor="#f5f5f5"
        foregroundColor="#ebebeb"
        animate={false}
        {...props}
      >
        <rect x="79" y="20" rx="0" ry="0" width="0" height="1" />
        {/* left */}
        <rect x="0" y="8" rx="0" ry="0" width="2" height="292" />
        <rect x="0" y="298" rx="0" ry="0" width="297" height="2" />
        {/* right */}
        <rect x="298" y="8" rx="20" ry="0" width="2" height="292" />
        <rect x="0" y="60" rx="0" ry="0" width="297" height="1" />
        {/* top */}
        <rect x="0" y="0" rx="8" ry="8" width="300" height="40" />
        <rect x="271" y="22" rx="4" ry="4" width="18" height="18" />
        {/* <rect x="186" y="76" rx="4" ry="4" width="81" height="9" />
        <rect x="150" y="63" rx="0" ry="0" width="2" height="44" /> */}
        <rect x="28" y="90" rx="4" ry="4" width="243" height="61" />
        <rect x="62" y="188" rx="4" ry="4" width="148" height="19" />
        <circle cx="39" cy="197" r="10" />
        <circle cx="39" cy="247" r="10" />
        <rect x="64" y="237" rx="4" ry="4" width="148" height="19" />
      </ContentLoader>
    </div>
  );
};

export default MatchInfoLoading;
